import script from "./TableCellDownload.vue?vue&type=script&setup=true&lang=js"
export * from "./TableCellDownload.vue?vue&type=script&setup=true&lang=js"

import "./TableCellDownload.vue?vue&type=style&index=0&id=f862140e&lang=css&scoped=true"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f862140e"]])

export default __exports__